import { Avatar } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { ReactNode } from "react";

interface IProps {
    title: ReactNode;
    slug: string;
    fetching?: boolean;
    icon: JSX.Element;
}

const InspectorModuleTitle: React.FC<IProps> = ({ title, slug, fetching, icon }: IProps) => {
    return (
        <>
            <h4 id={"tag-" + slug}>
                <Avatar size="small" className={"group-icon"} style={{ marginRight: 10 }} icon={icon} />
                {title}
                {fetching !== null && fetching && (
                    <span key={slug} style={{ display: "inline-block", justifyContent: "left", paddingLeft: 10 }}>
                        <LoadingOutlined style={{ fontSize: 16 }} spin />
                    </span>
                )}
            </h4>
        </>
    );
};
export default InspectorModuleTitle;
